import React, {
  createContext,
  useContext,
  useState,
  useEffect
} from 'react';
import { useAuth } from '../auth';
import { postJSON } from '@/utils/http';
import { Icon } from 'semantic-ui-react';

const DataStructuresContext = createContext();

function DataStructuresProvider ({ children }) {
  // whatever you set here as default, will be used in both server side and client as well
  const { data:userData } = useAuth();
  const [providerData, setProviderData] = useState({
    ready: false,
    data: {
      // add default data to your provider here
    }
  });

  // you can get extra data asynchronously if needed
  // this will only affect the client side
  async function fetchProviderData () {
    let loading = false;
    const currProviderData = {...providerData};
    if (userData && userData.isAuthenticated) {
      // let's fetch it
      loading = true;
      postJSON(
        '/api/data_structures/list',
        {
          lookupOrGrid: 'Grid',
          includeModuleInfo: true
        }
      ).then(({data, error}) => {
        if (error) {
          console.error(`Failed to retrieve the list of available DataStructures Module information`, error);
        }
        currProviderData.data = data;
      }).finally(_ => {
        const obj = {};
        currProviderData?.data?.forEach(ds => {
          const { moduleInfo, ...dsInfo } = ds;
          const key = `DS@` + moduleInfo.name;

          const exposes = [];

          [
            moduleInfo?.crud_listing,
            moduleInfo?.crud_upsert
          ].forEach((info, i) => {

            if (!info) {
              return;
            }

            const {
              title,
              icon,
              ...rest
            } = (info || {});

            exposes.push({
              title,
              action: {
                module: 'DSCrudModules' + (i > 0 ? 'Details' : ''),
                props: {
                  DS: dsInfo,
                  moduleInfo
                },
                options: {
                  ...info,
                  icon: function TheIcon (props) {
                    return (
                      <Icon
                        name={icon?.icon || 'info'}
                        style={{
                          color: icon?.color || 'unset'
                        }}
                        {...props}
                      />
                    );
                  },
                },
              },
              windowOptions: rest
            });
          });

          function TheIcon (props) {
            return (
              <Icon
                name={moduleInfo.crud_listing?.icon?.icon || 'info'}
                style={{
                  color: moduleInfo.crud_listing?.icon?.color || 'unset'
                }}
                {...props}
              />
            );
          }

          obj[key] = {
            "id": ds.id,
            "type": "DataStructureModule",
            // "fileName": 'dscrudmodules',
            "title": moduleInfo.title,
            "icon": TheIcon,
            "category": moduleInfo.menu_category,
            "exposes": exposes,
            "unique": moduleInfo.unique,
            "version": "1.0.0",
            "description": "A screen abbout the current version of the project",
            "windowOptions": {...(moduleInfo.crud_listing || {})}
          };

          currProviderData.data = obj;
        });
        setProviderData({
          ...currProviderData,
          loading: false
        });
      });
    } else {
      currProviderData.data = {};
    }

    setProviderData({
      ...currProviderData,
      ready: true,
      loading
    });
  }

  useEffect(() => { fetchProviderData(); }, [
    userData.isAuthenticated
  ]);

  const value = {
    ...providerData,
    refresh: () => {
      return fetchProviderData();
    },
    setData (key, value) {
      setProviderData({
        ...providerData,
        data: {
          ...providerData.data,
          [key]: value
        }
      });
    }
    // TODO: add more methods/actions here
  };

  return (
    <DataStructuresContext.Provider value={value}>

      {children}

      {/*
        //! you can add extra components here
       */}
    </DataStructuresContext.Provider>
  );
}

// this allows you to use it as a simpler hook
function useDataStructures () {
  const context = useContext(DataStructuresContext);
  if (context === undefined) {
    throw new Error(`useDataStructures must be used within a DataStructuresProvider`);
  }

  return context;
}

export {
  DataStructuresProvider,
  DataStructuresContext,
  useDataStructures
};
